import { Component, OnInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap';
//import 'ag-grid-enterprise/main';
import { LoopBackFilter } from '../../../sdk/models';
import { DataelementApi } from '../../../sdk/services/custom';
import { NotificationsService } from 'angular2-notifications';
import { PlatformApp } from '../../../services/app.service';
@Component({
    selector: 'metric-target-widget',
    templateUrl: './metric-target.component.html',
    providers: [DataelementApi],
    styleUrls: ['./metric-target.component.scss']

})

export class MetricTargetWidgetComponent implements OnInit, OnDestroy {
    @Input() id: string;
    @Input() title = '';
    @Input() widget: any;
    dataelement: any;
    subscriptions: any = [];
    metricvalue = 0;
    @ViewChild('childModal') public childModal: ModalDirective;
    notifyOptions = PlatformApp.getNotificationOptions();
    public showChildModal(): void {
        this.childModal.show();
    }

    public hideChildModal(): void {
        this.childModal.hide();
    }

    constructor(private _DataelementApi: DataelementApi,
        private _NotificationsService: NotificationsService) {

    }

    ngOnInit(): void {
        this.getWidgetData();
    }

    public getWidgetData() {
        let filter: LoopBackFilter = {};
        filter['data'] = true;
        this.subscriptions.push(this._DataelementApi.findById(this.id, filter)
            .subscribe((result) => {
                if (result && result["data"]) {
                    this.dataelement = result;
                    let metricvaluefieldname = this.dataelement['fields'][0].name;
                    if (this.dataelement['data'] && this.dataelement['data'][0]) {
                        this.metricvalue = this.dataelement['data'][0][metricvaluefieldname];
                    }
                }
            }));
    }

    ngOnDestroy() {
        for (var i = 0; i < this.subscriptions.length; i++) this.subscriptions[i].unsubscribe();
    }

    notify(type, title?, content?, options?) {
        if (!options) options = PlatformApp.getNotificationOptions();
        if (!options.id) options.id = type + '-' + title + '_' + content;
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/metric-target/metric-target.component.ts